import {
    LIST_FUNCTIONARY_TYPES,
    LIST_FUNCTIONARY_TYPES_SUCCESS,
    LIST_FUNCTIONARY_TYPES_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import functionaryTypesData from '../data/functionaryTypes';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';

const controller = 'funcionario-tipo';

//LISTAR FUNCTIONARY TYPES
export function listFunctionaryTypesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listFunctionaryTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const functionaryTypes = response.data;
            //const functionaryTypes = functionaryTypesData;
            //Llamo al dispatch
            dispatch( listFunctionaryTypesSuccess(functionaryTypes.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listFunctionaryTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listFunctionaryTypes = () => ({
    type: LIST_FUNCTIONARY_TYPES,
    payload: true
});

const listFunctionaryTypesSuccess = functionaryTypes => ({
    type: LIST_FUNCTIONARY_TYPES_SUCCESS,
    payload: functionaryTypes
});

const listFunctionaryTypesError = error => ({
    type: LIST_FUNCTIONARY_TYPES_ERROR,
    payload: error
});